import React from 'react';
import PropTypes from 'prop-types';

import Card from './card';

import styles from '../styles/uikitCardsCardContent.module.scss';

const CardContent = ({ children, className = '', testId = '' }) => (
  <Card className={className} testId={testId}>
    <div className={styles.content}>
      {children}
    </div>
  </Card>
);

CardContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default React.memo(CardContent);
